import {registerProviderBank, getProvider, searchActes, getProviderType, searchActesConsult, registerProviderMobileMoney, getAllProviders, getFacturation} from '../../services/ProviderService';
import blobFileUpload from '../../services/BlobStorageService';
import { errorToastr, successToastr } from '../../Utils/ToastrMessage';


export const GET_PROVIDER_DATA_CONFIRMED_ACTION = '[getProvider action] confirmed getProvider';
export const GET_PROVIDER_DATA_FAILED_ACTION = '[getProvider action] failed getProvider';

export const START_LOADER_ACTION = '[providerLoader action] started providerLoader';

export const REGISTER_PROVIDER_BANK_FAILED_ACTION = '[createProviderBank action] failed createProviderBank';
export const REGISTER_PROVIDER_BANK_CONFIRMED_ACTION = '[createProviderBank action] confirmed createProviderBank';


export const SEARCH_ACTES_CONFIRMED_ACTION = '[searchActes action] confirmed searchActes';
export const SEARCH_ACTES_FAILED_ACTION = '[searchActes action] failed searchActes';

export const SEARCH_ACTES_SPEC_CONFIRMED_ACTION = '[searchActesSpec action] confirmed searchActesSpec';
export const SEARCH_ACTES_SPEC_FAILED_ACTION = '[searchActesSpec action] failed searchActesSpec';

export const SEARCH_ACTES_DEP_KINE_CONFIRMED_ACTION = '[searchActesDepKine action] confirmed searchActesDepKine';
export const SEARCH_ACTES_DEP_KINE_FAILED_ACTION = '[searchActesDepKine action] failed searchActesDepKine';

export const GET_PROVIDER_CONFIRMED_ACTION = '[getProviders action] confirmed getProviders';
export const GET_PROVIDER_FAILED_ACTION = '[getProviders action] failed getProviders';

export const GET_FACTURE_CONFIRMED_ACTION = '[getFacture action] confirmed getFacture';
export const GET_FACTURE_FAILED_ACTION = '[getFacture action] failed getFacture';

export const GET_PROVIDER_TYPES_CONFIRMED_ACTION = '[getProviderType action] confirmed getProviderType';
export const GET_PROVIDER_TYPES_FAILED_ACTION = '[getProviderType action] failed getProviderType';

export const GET_PROVIDERS_STATUS = 'GET_PROVIDERS_STATUS';

var I18n = require('react-redux-i18n').I18n;

export const getProviderDataAction = (id, history) => {
    
    return (dispatch) => {
        getProvider(id)
        .then((response) => {
            
            dispatch(confirmedGetProviderAction(response.data));
        })
        .catch((error) => {
            errorToastr(I18n.t('provider.get_error')+error.response?.data?.message);
            dispatch(getProviderFailedAction(error.response?.data?.message));
            //history.goBack();
        });
    };
};

export const addProviderBank = (bankData, history) => {
    return async (dispatch) => {
        if (bankData.bankDetail.fileSrc) {
            let res = await blobFileUpload([bankData.bankDetail.fileSrc], 'amp-providers-container');
            bankData.bankDetail['ribPhoto'] = res[0];
        }

        /*let datas = bankData.paymentMeans.map(async bdata => {
            bdata['providerId'] = bankData.providerId;
            if(bdata.file) {
                let res = await blobFileUpload([bdata.file], 'amp-providers-container');
                bdata['idPhoto'] = res[0];
            }
            return bdata;
        })*/

        let datas = [];
        for (let i = 0; i<bankData.paymentMeans.length; i++){
            let mmdata = bankData.paymentMeans[i];
            mmdata['providerId'] = bankData.providerId;

            if(bankData.paymentMeans[i].file) {
                let res = await blobFileUpload([bankData.paymentMeans[i].file], 'amp-providers-container');
                mmdata['idPhoto'] = res[0];
            }
            datas.push(mmdata);
        }


        let finalData = {
            bankAccount: {providerId: bankData.providerId, ...bankData.bankDetail},
            mobileAccount: datas,
        }

        registerProviderBank(finalData).then((response) => {
            dispatch(confirmedRegisterProviderBankAction(response.data));
            history.push('/provider-view/'+bankData.providerId);
        })
        .catch((error) => {
            errorToastr(I18n.t('provider.add_prov_bank_error')+error.response?.data?.message);
            dispatch(registerProviderBankFailedAction(error.response?.data?.message));
        });
    };
};

export const searchActesAction = (keyword, providerId, type) => {
    
    return (dispatch) => {
        searchActesConsult(keyword, providerId, type)
        .then((response) => {
            
            dispatch(confirmedSearchActesAction(response.data));
        })
        .catch((error) => {
            errorToastr(I18n.t('provider.search_act_error')+error.response?.data?.message);
            dispatch(searchActesFailedAction(error.response?.data?.message));
            //history.goBack();
        });
    };
};

export const searchActesSpecAction = (keyword, providerId, type) => {
    
    return (dispatch) => {
        searchActesConsult(keyword, providerId, type)
        .then((response) => {
            
            dispatch(confirmedSearchActesSpecAction(response.data));
        })
        .catch((error) => {
            errorToastr(I18n.t('provider.search_spec_act_error')+error.response?.data?.message);
            dispatch(searchActesSpecFailedAction(error.response?.data?.message));
            //history.goBack();
        });
    };
};



export const searchActesDepKineAction = (keyword, providerId, type) => {
    
    return (dispatch) => {
        searchActesConsult(keyword, providerId, type)
        .then((response) => {
            
            dispatch(confirmedSearchActesDepKineAction(response.data));
        })
        .catch((error) => {
            errorToastr(I18n.t('provider.search_spec_act_error')+error.response?.data?.message);
            dispatch(searchActesDepKineFailedAction(error.response?.data?.message));
            //history.goBack();
        });
    };
};

export const listProvidersAction = () => {
    
    return (dispatch) => {
        getAllProviders()
        .then((response) => {
            
            dispatch(confirmedProviderListAction(response.data));
        })
        .catch((error) => {
            errorToastr(I18n.t('provider.list_providers_error')+error.response?.data?.message);
            dispatch(providerListFailedAction(error.response?.data?.message));
        });
    };
};

export const getFactureAction = (data) => {
    
    return (dispatch) => {
        getFacturation(data)
        .then((response) => {
            
            dispatch(confirmedGetFactureAction(response.data));
        })
        .catch((error) => {
            errorToastr(I18n.t('provider.calculate_facture_error')+error.response?.data?.message);
            dispatch(getFactureFailedAction(error.response?.data?.message));
            //history.goBack();
        });
    };
};

export const getProvidersTypesAction = () => {
    return (dispatch) => {
        getProviderType().then((response) => {
            
            dispatch(confirmedGetProviderTypesAction(response.data));
        })
        .catch((error) => {
            errorToastr(I18n.t('provider.get_type_error')+error.response?.data?.message);
            dispatch(getProviderTypesFailedAction(error.response?.data?.message));
        });
    };
};

// export const getProvidersStatusAction = (params) => {
//     return async dispatch => {
//         getProviderType().then((response) => {
            
//             dispatch({
//                 type: GET_PROVIDERS_STATUS,
//                 payload: response.data
//               });
//         })
//         .catch((error) => {
//             errorToastr(I18n.t('provider.get_type_error')+error.response?.data?.message);
//             dispatch(getProviderTypesFailedAction(error.response?.data?.message));
//         });
//     };
//   };

export function confirmedGetProviderTypesAction(payload) {
    return {
        type: GET_PROVIDER_TYPES_CONFIRMED_ACTION,
        payload,
    };
};

export function getProviderTypesFailedAction(payload) {
    return {
        type: GET_PROVIDER_TYPES_FAILED_ACTION,
        payload,
    };
};


export function confirmedGetProviderAction(payload) {
    return {
        type: GET_PROVIDER_DATA_CONFIRMED_ACTION,
        payload,
    };
};

export function getProviderFailedAction(payload) {
    return {
        type: GET_PROVIDER_DATA_FAILED_ACTION,
        payload,
    };
};

export function startLoader() {
    return {
        type: START_LOADER_ACTION
    };
};


export function confirmedRegisterProviderBankAction(payload) {
    return {
        type: REGISTER_PROVIDER_BANK_CONFIRMED_ACTION,
        payload,
    };
};

export function registerProviderBankFailedAction(payload) {
    return {
        type: REGISTER_PROVIDER_BANK_FAILED_ACTION,
        payload,
    };
};

export function confirmedSearchActesAction(payload) {
    return {
        type: SEARCH_ACTES_CONFIRMED_ACTION,
        payload,
    };
};

export function searchActesFailedAction(payload) {
    return {
        type: SEARCH_ACTES_FAILED_ACTION,
        payload,
    };
};

export function confirmedSearchActesSpecAction(payload) {
    return {
        type: SEARCH_ACTES_SPEC_CONFIRMED_ACTION,
        payload,
    };
};

export function searchActesSpecFailedAction(payload) {
    return {
        type: SEARCH_ACTES_SPEC_FAILED_ACTION,
        payload,
    };
};

export function confirmedSearchActesDepKineAction(payload) {
    return {
        type: SEARCH_ACTES_DEP_KINE_CONFIRMED_ACTION,
        payload,
    };
};

export function searchActesDepKineFailedAction(payload) {
    return {
        type: SEARCH_ACTES_DEP_KINE_FAILED_ACTION,
        payload,
    };
};

export function confirmedProviderListAction(payload) {
    return {
        type: GET_PROVIDER_CONFIRMED_ACTION,
        payload,
    };
};

export function providerListFailedAction(payload) {
    return {
        type: GET_PROVIDER_FAILED_ACTION,
        payload,
    };
};

export function confirmedGetFactureAction(payload) {
    return {
        type: GET_FACTURE_CONFIRMED_ACTION,
        payload,
    };
};

export function getFactureFailedAction(payload) {
    return {
        type: GET_FACTURE_FAILED_ACTION,
        payload,
    };
};
